module.exports = "/logo-no-text-03554efe827d57c0e949b702dfaddede.svg";